<template>
  <div
    class="menuControlPage"
    v-if="false"
    :style="{
      width: isShow ? itemWidth + 20 + 'px' : itemWidth * 3 + 20 + 'px',
    }"
  >
    <div class="menuBox">
      <div
        class="menuList"
        :style="{
          left: isShow ? '-0' - activeIndex * itemWidth + 'px' : '0',
          width: itemWidth * menuList.length,
        }"
      >
        <div
          :class="['menuItem', index != activeIndex && 'menuItemActive']"
          :style="{ width: itemWidth + 'px' }"
          v-for="(item, index) in menuList"
          :key="index"
          @click="changeActive(index)"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
    <div class="switchBtm" @click="switchList"></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  switchOutside, //开关厂棚外侧
  switchLight, // 开关光照
  switchTarget, // 显隐光标
  switchPillar, // 显隐藏中立柱
  switchAllEqmHL, //开关设备高亮
  switchPartEqmHL, //开关部分设备高亮
  switchSingleHL, // 单个设备高亮
  ChangePileSizeFunc, //改变料堆大小
  switchAreaWarn, //开关告警区域
  switchAreaWarnClean, //开关已治理告警区域
  switchVDM3500, //开关vdm3500
  switchVDM150, //开关vdm150
  switchFogGun, // 开关雾炮
  switchMediaArea, //切换视频区域
} from "@/assets/js/unity3D/shed.js";
import { ElNotification } from "element-plus";

export default {
  setup() {
    const openSuccess = (data, text) => {
      let word = data ? (data[0] ? "西侧" : "东侧") : "" + text;
      ElNotification({
        type: "success",
        offset: 65,
        message: '<span style="color:white">' + word + "</span>",
        dangerouslyUseHTMLString: true,
        duration: 3000,
        customClass: "shedNote",
      });
    };

    const openWarn = (data, text) => {
      // let word = (data[0] ? "西侧" : "东侧") + data[2] + "号区域";
      let word = (data[0] ? "西侧" : "东侧") + text;
      ElNotification({
        type: "warning",
        offset: 45,
        message: '<span style="color:white">' + word + "</span>",
        dangerouslyUseHTMLString: true,
        duration: 0,
        customClass: "shedNote",
      });
    };

    const openInfo = (data, text) => {
      let word = (data[0] ? "西侧" : "东侧") + text;
      ElNotification({
        type: "info",
        offset: 45,
        message: '<span style="color:white">' + word + "</span>",
        dangerouslyUseHTMLString: true,
        duration: 0,
        customClass: "shedNote",
      });
    };
    return {
      openSuccess,
      openWarn,
      openInfo,
    };
  },
  data() {
    //这里存放数据
    return {
      menuList: [
        { text: "高污染治理模式" },
        { text: "常规污染治理模式" },
        { text: "检修模式" },
      ],
      isShow: true,
      activeIndex: 0,
      itemWidth: 230,
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeUnmount() {},
  //方法集合
  methods: {
    changeActive(index) {
      this.activeIndex = index;
      if (!this.isShow) this.switchList();
    },
    switchList() {
      this.isShow = !this.isShow;
      this.openSuccess(false, "含水率监测到含水率较低 开启干雾治理");
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.menuControlPage {
  height: 70px;
  line-height: 70px;
  position: absolute;
  left: 40px;
  right: 0px;
  bottom: 150px;
  transition: all 1s;
  font-size: 20px;
  .menuBox {
    width: 100%;
    height: 70px;
    line-height: 70px;
    position: absolute;
    background: rgba(3, 1, 30, 0.7);
    border-radius: 35px;
    border: 1px solid #103688;
    filter: blur(0px);
    overflow: hidden;
    .menuList {
      transition: all 1s;
      display: flex;
      position: absolute;
      .menuItem {
        text-align: center;
        cursor: pointer;
        letter-spacing: 1px;
        color: white;
      }
      .menuItemActive {
        color: #b1b1b1;
      }
      .menuItemActive:hover {
        color: rgba(160, 186, 248, 1);
      }
    }
  }
  .switchBtm {
    transition: all 1s;
    position: absolute;
    right: -18px;
    width: 72px;
    height: 72px;
    background: url("./img/roundBtn.png") no-repeat;
    background-size: 100%;
  }
}
</style>